export const typeInfo = Object.freeze({
  analysis: {
    text: "지문분석",
    color: "#1DB05B",
    backgroundColor: "#E8F7EE",
    answerTextColor: "white",
    badgeColor: "rgba(29, 176, 91, 0.35)",
  },
  comprehensive: {
    text: "내용이해",
    color: "#E8920A", // [색 스왑] 원래 톤 복귀 — 내용이해=오렌지
    backgroundColor: "#FDF3E3",
    answerTextColor: "white",
    badgeColor: "rgba(232, 146, 10, 0.35)",
  },
  paragraph: {
    text: "모의고사",
    color: "#C2452D",
    backgroundColor: "#FCEDE9",
    answerTextColor: "white",
    badgeColor: "rgba(194, 69, 45, 0.32)",
  },
  vocabulary: {
    text: "단어테스트",
    color: "#3E6398",
    backgroundColor: "#E9EFF7",
    answerTextColor: "white",
    badgeColor: "rgba(62, 99, 152, 0.32)",
  },
  sentence: {
    text: "문장테스트",
    color: "#8A6D00",
    backgroundColor: "#FBF4D9",
    answerTextColor: "white",
    badgeColor: "rgba(138, 109, 0, 0.32)",
  },
  // 지인에듀 수학 학습지(2026-10-06). 연산(드릴)은 청록, 유형은 보라 · 풀이 화면의 색과 맞춘다
  math_type_worksheet: {
    text: "수학 유형",
    color: "#6A5AE0",
    backgroundColor: "#EFEDFC",
    answerTextColor: "white",
    badgeColor: "rgba(106, 90, 224, 0.32)",
  },
  math_variant: {
    text: "수학 변형",
    color: "#6A5AE0",
    backgroundColor: "#EFEDFC",
    answerTextColor: "white",
    badgeColor: "rgba(106, 90, 224, 0.32)",
  },
  math_concept: {
    text: "수학 개념",
    color: "#6A5AE0",
    backgroundColor: "#EFEDFC",
    answerTextColor: "white",
    badgeColor: "rgba(106, 90, 224, 0.32)",
  },
  // 오답노트 쌍둥이 과제(2026-10-06). 오답 표시와 같은 분홍
  math_wrong_note: {
    text: "수학 오답",
    color: "#D63C5E",
    backgroundColor: "#FFE8EE",
    answerTextColor: "white",
    badgeColor: "rgba(214, 60, 94, 0.32)",
  },
  math_drill: {
    text: "수학 연산",
    color: "#00A396",
    backgroundColor: "#E6F7F4",
    answerTextColor: "white",
    badgeColor: "rgba(0, 163, 150, 0.32)",
  },
  // 리더스북(지인에듀, 2026-10-17). 교사 화면 WorksheetTypeBox 와 같은 색
  readers_book: {
    text: "리더스북",
    color: "#D14D72",
    backgroundColor: "#FCEBF1",
    answerTextColor: "white",
    badgeColor: "rgba(209, 77, 114, 0.32)",
  },
  bank: {
    text: "문제뱅크",
    color: "#00A396",
    backgroundColor: "#EFFBF8",
    answerTextColor: "white",
    badgeColor: "rgba(0, 163, 150, 0.32)",
  },
  grammar: {
    text: "어법테스트",
    color: "#6B4EE6", // [색 스왑] 원래 톤 복귀 — 어법=보라
    backgroundColor: "#EFEBFC",
    answerTextColor: "white",
    badgeColor: "rgba(107, 78, 230, 0.32)",
  },
  paper_assignment: {
    text: "지필과제",
    color: "#00A396",
    backgroundColor: "#E5FBF8",
    answerTextColor: "white",
    badgeColor: "rgba(0, 163, 150, 0.32)",
  },
  class_content: {
    text: "수업결과",
    color: "#3A434E",
    backgroundColor: "#F4F8F7",
    answerTextColor: "white",
    badgeColor: "rgba(58, 67, 78, 0.28)",
  },
});

export const SENTENCE_SECTION_ORDER = {
  translation: 1,    // 해석
  blank: 2,          // 빈칸
  scramble: 3,       // 스크램블
  composition: 4,    // 영작
  comprehensive: 5,  // 종합
  dictation: 6,      // 받아쓰기
};
